// extracted by mini-css-extract-plugin
export default {"container":"RYlKIe","header":"Oi_qe3","link":"EiFrgy"};